import { LoadingAnimation } from '@hrworks/sui-core/LoadingAnimation';

import { S } from './LoadingScreen.styles';
import type { LoadingScreenProps } from './LoadingScreen.types';

/**
 * Full-screen loading indicator with optional message
 * Uses SmartFace LoadingAnimation component
 */
export const LoadingScreen = ({ message = 'Loading...' }: LoadingScreenProps) => {
  return (
    <S.Container>
      <LoadingAnimation type="spinner" />
      {message && <S.Message>{message}</S.Message>}
    </S.Container>
  );
};
